import React from 'react'
import CreateAccountManagement from '../../../features/Accountmanagement/CreateAccountManagement/CreateAccountManagement'

const AccountManagement = () => {
    return (
        <CreateAccountManagement />
    )
}

export default AccountManagement